import { render, staticRenderFns } from "./dashboard-chapter-progress-component.vue?vue&type=template&id=47907986&scoped=true&"
import script from "./dashboard-chapter-progress-component.vue?vue&type=script&lang=ts&"
export * from "./dashboard-chapter-progress-component.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-chapter-progress-component.vue?vue&type=style&index=0&id=47907986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47907986",
  null
  
)

export default component.exports